<template>
  <div class="CS5">
    <div class="CS5-left">
      <div class="CS5-phone">
        <img src="@/assets/green-phone.png" />
      </div>
      <div class="CS5-video">
        <img src="@/assets/temp_main.png" />
        <!-- <video muted autoplay loop playsinline>
          <source
            src="https://qyuyzyggndee2252511.gcdn.ntruss.com/images/video-1.mp4"
            type="video/mp4"
          />
        </video>-->
      </div>
    </div>
    <div class="CS5-right">
      <div class="CS5R-title1">WE ARE NOW</div>
      <div class="CS5R-title2">Live Commerce Platform</div>
      <div
        class="CS5R-description"
      >"ON STYLE LIVE" 는 5G와 AI기술을 바탕으로 한 라이브 방송 + 쇼핑이 결합된 통합 라이브 커머스 플랫폼 서비스입니다.</div>
      <div class="CS5R-list">
        <ul>
          <li>WebRTC &#38; AdaPtive Bitrate Live Streaming</li>
          <li>AWCS(Advanced Web Crawling System)</li>
          <li>AUBRS(Advanced User Based Recommendation System)</li>
          <li>Cloud Server Service</li>
          <li>Socket.io &#38; Redis Chatting Service</li>
          <li>N-screen Service</li>
        </ul>
      </div>
      <div class="CS5R-btn">
        <router-link to="/product" class="CS5R-link">ON STYLE LIVE 알아보기</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CompanySlide5"
};
</script>
<style lang="scss" scoped>
.CS5 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
  position: relative;

  .CS5-left {
    width: 50%;
    background-color: #bfdfd9;
    padding-top: 50px;
    padding-bottom: 50px;
    box-sizing: border-box;
    text-align: center;
    overflow: hidden;
    position: relative;

    .CS5-phone {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: 290px;
      height: 602px;
    }

    .CS5-video {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: 272px;
      height: 568px;
      border-radius: 24px;
      overflow: hidden;
      object-fit: contain;

      video,
      img {
        width: 272px;
        height: 568px;
      }
    }
  }

  .CS5-right {
    width: 50%;
    height: 100%;
    padding-left: 50px;
    padding-right: 150px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .CS5R-title1 {
      font-size: 24px;
      color: #a1a1a1;
      margin-bottom: 10px;
    }

    .CS5R-title2 {
      font-size: 40px;
      font-weight: 900;
      color: #00a79d;
      margin-bottom: 20px;
    }

    .CS5R-description {
      font-size: 20px;
      color: #a1a1a1;
      line-height: 36px;
      margin-bottom: 50px;
    }
    .CS5R-list {
      margin-bottom: 50px;
      li {
        font-size: 20px;
        margin-bottom: 10px;
        color: #a1a1a1;
      }
    }
    .CS5R-btn {
      width: 300px;
      height: 50px;
      background-color: #00a79d;
      border-radius: 25px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      .CS5R-link {
        text-decoration: none;
        color: #fff;
        font-size: 18px;
      }
      &:hover {
        background-color: #006d66;
        cursor: pointer;
      }
    }
  }
}
</style>